(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["garde-social-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class GardeSocialProducts {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector("[data-gsp-viewport]");
      this.track = section.querySelector("[data-gsp-track]");
      this.prev = section.querySelector("[data-gsp-prev]");
      this.next = section.querySelector("[data-gsp-next]");

      if (!this.viewport || !this.track) return;

      this.update = this.update.bind(this);
      this.viewport.addEventListener("scroll", this.update, { passive: true });
      window.addEventListener("resize", this.update);

      if (this.prev) this.prev.addEventListener("click", () => this.scroll(-1));
      if (this.next) this.next.addEventListener("click", () => this.scroll(1));

      this.update();
    }

    scroll(direction) {
      const slide = this.track.querySelector(".garde-social-products__slide");
      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 16;
      const distance = slide ? slide.getBoundingClientRect().width + gap : this.viewport.clientWidth * 0.8;
      this.viewport.scrollBy({ left: direction * distance, behavior: "smooth" });
    }

    update() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      if (this.prev) this.prev.disabled = this.viewport.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.viewport.scrollLeft >= max - 2;
    }
  }

  const initGardeSocialProducts = (scope = document) => {
    scope.querySelectorAll("[data-gsp-section]").forEach((section) => {
      if (!section.gardeSocialProducts) {
        section.gardeSocialProducts = new GardeSocialProducts(section);
      }
    });
  };

  initGardeSocialProducts();
  document.addEventListener("shopify:section:load", (event) => initGardeSocialProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaanuu-shop-by-color-carousel"] && !Shopify.designMode) return;
  try {
    
  class JaanColorCarousel {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector("[data-jcc-viewport]");
      this.track = section.querySelector("[data-jcc-track]");
      this.prev = section.querySelector("[data-jcc-prev]");
      this.next = section.querySelector("[data-jcc-next]");
      this.progress = section.querySelector("[data-jcc-progress]");

      if (!this.viewport || !this.track) return;

      this.onScroll = this.update.bind(this);
      this.viewport.addEventListener("scroll", this.onScroll, { passive: true });

      if (this.prev) {
        this.prev.addEventListener("click", () => this.scroll(-1));
      }

      if (this.next) {
        this.next.addEventListener("click", () => this.scroll(1));
      }

      this.update();
      window.addEventListener("resize", this.onScroll);
    }

    scroll(direction) {
      const firstSlide = this.track.querySelector(".jaan-color-carousel__slide");
      const distance = firstSlide ? firstSlide.getBoundingClientRect().width : this.viewport.clientWidth * 0.85;
      this.viewport.scrollBy({ left: direction * distance, behavior: "smooth" });
    }

    update() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const current = max > 0 ? this.viewport.scrollLeft / max : 0;

      if (this.prev) {
        this.prev.disabled = this.viewport.scrollLeft <= 2;
      }

      if (this.next) {
        this.next.disabled = this.viewport.scrollLeft >= max - 2;
      }

      if (this.progress) {
        const visibleRatio = this.viewport.clientWidth / this.viewport.scrollWidth;
        const barWidth = Math.max(visibleRatio * 100, 16);
        const travel = 100 - barWidth;
        this.progress.style.width = `${barWidth}%`;
        this.progress.style.transform = `translateX(${current * travel}%)`;
      }
    }
  }

  const initJaanColorCarousels = (scope = document) => {
    scope.querySelectorAll("[data-jcc-section]").forEach((section) => {
      if (!section.jaanColorCarousel) {
        section.jaanColorCarousel = new JaanColorCarousel(section);
      }
    });
  };

  initJaanColorCarousels();
  document.addEventListener("shopify:section:load", (event) => initJaanColorCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-scrubs-custom"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-scrub-pdp]').forEach(function(section){
  var variantsEl=section.querySelector('[data-variants]');
  var variants=variantsEl?JSON.parse(variantsEl.textContent):[];
  var idInput=section.querySelector('[data-variant-id]');
  var price=section.querySelector('[data-price]');
  var add=section.querySelector('[data-add]');
  var addText=section.querySelector('[data-add-text]');
  var qty=section.querySelector('[data-qty]');
  var formatter=new Intl.NumberFormat(undefined,{style:'currency',currency:section.dataset.currency||'USD'});
  function selected(){var values=[];section.querySelectorAll('[data-option-input]:checked').forEach(function(input){values[Number(input.dataset.optionIndex)]=input.value});return values}
  function update(){var values=selected();var variant=variants.find(function(item){return item.options.every(function(value,index){return value===values[index]})});if(!variant)return;idInput.value=variant.id;if(price)price.textContent=formatter.format(variant.price/100);if(add&&addText){add.disabled=!variant.available;addText.textContent=variant.available?'Add to Bag':'Sold Out'}values.forEach(function(value,index){var label=section.querySelector('[data-option-label="'+index+'"]');if(label)label.textContent=value})}
  section.querySelectorAll('[data-option-input]').forEach(function(input){input.addEventListener('change',update)});
  section.querySelectorAll('[data-minus]').forEach(function(button){button.addEventListener('click',function(){qty.value=Math.max(1,Number(qty.value||1)-1)})});
  section.querySelectorAll('[data-plus]').forEach(function(button){button.addEventListener('click',function(){qty.value=Number(qty.value||1)+1})});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mandala-difference-transparency"] && !Shopify.designMode) return;
  try {
    
  class MandalaDifferenceTabs {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll("[data-mandala-tab]"));
      this.panels = Array.from(root.querySelectorAll("[data-mandala-panel]"));
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", () => this.activate(tab.dataset.mandalaTab));
      });
    }

    activate(id) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.mandalaTab === id;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.mandalaPanel === id;
        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
      });
    }
  }

  const initMandalaDifferenceTabs = (scope = document) => {
    scope.querySelectorAll("[data-mandala-tabs]").forEach((root) => {
      if (!root.mandalaDifferenceTabs) {
        root.mandalaDifferenceTabs = new MandalaDifferenceTabs(root);
      }
    });
  };

  initMandalaDifferenceTabs();

  document.addEventListener("shopify:section:load", (event) => initMandalaDifferenceTabs(event.target));
  document.addEventListener("shopify:block:select", (event) => {
    const panel = event.target.closest("[data-mandala-panel]");
    if (panel) {
      const root = panel.closest("[data-mandala-tabs]");
      if (root && root.mandalaDifferenceTabs) {
        root.mandalaDifferenceTabs.activate(panel.dataset.mandalaPanel);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrub-lab-design-accordion"] && !Shopify.designMode) return;
  try {
    
  class ScrubLabDesignRotator {
    constructor(section) {
      this.section = section;
      this.items = Array.from(section.querySelectorAll("[data-sld-item]"));
      this.images = Array.from(section.querySelectorAll("[data-sld-image]"));
      this.autoplay = section.dataset.sldAutoplay === "true";
      this.interval = Number(section.dataset.sldInterval) || 5000;
      this.index = 0;
      this.timer = null;
      this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (!this.items.length || !this.images.length) return;

      this.items.forEach((item, index) => {
        const summary = item.querySelector("summary");
        if (summary) {
          summary.addEventListener("click", (event) => {
            event.preventDefault();
            this.activate(index);
            this.restart();
          });
        }
      });

      this.activate(0);
      this.start();
    }

    activate(index) {
      this.index = index;
      this.items.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.open = active;
        item.classList.toggle("is-active", active);
      });
      this.images.forEach((image, imageIndex) => {
        image.classList.toggle("is-active", imageIndex === index);
      });
    }

    next() {
      const nextIndex = (this.index + 1) % this.items.length;
      this.activate(nextIndex);
    }

    start() {
      if (!this.autoplay || this.reducedMotion || this.items.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  const initScrubLabDesignRotators = (scope = document) => {
    scope.querySelectorAll("[data-sld-section]").forEach((section) => {
      if (!section.scrubLabDesignRotator) {
        section.scrubLabDesignRotator = new ScrubLabDesignRotator(section);
      }
    });
  };

  initScrubLabDesignRotators();
  document.addEventListener("shopify:section:load", (event) => initScrubLabDesignRotators(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simon-style-review-carousel"] && !Shopify.designMode) return;
  try {
    
  class SimonReviewCarousel {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector("[data-src-viewport]");
      this.track = section.querySelector("[data-src-track]");
      this.prev = section.querySelector("[data-src-prev]");
      this.next = section.querySelector("[data-src-next]");

      if (!this.viewport || !this.track) return;

      this.update = this.update.bind(this);
      this.viewport.addEventListener("scroll", this.update, { passive: true });
      window.addEventListener("resize", this.update);

      if (this.prev) this.prev.addEventListener("click", () => this.scroll(-1));
      if (this.next) this.next.addEventListener("click", () => this.scroll(1));

      this.update();
    }

    scroll(direction) {
      const review = this.track.querySelector(".simon-review-carousel__review");
      const distance = review ? review.getBoundingClientRect().width + 34 : this.viewport.clientWidth * 0.8;
      this.viewport.scrollBy({ left: direction * distance, behavior: "smooth" });
    }

    update() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      if (this.prev) this.prev.disabled = this.viewport.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.viewport.scrollLeft >= max - 2;
    }
  }

  const initSimonReviewCarousels = (scope = document) => {
    scope.querySelectorAll("[data-src-section]").forEach((section) => {
      if (!section.simonReviewCarousel) {
        section.simonReviewCarousel = new SimonReviewCarousel(section);
      }
    });
  };

  initSimonReviewCarousels();
  document.addEventListener("shopify:section:load", (event) => initSimonReviewCarousels(event.target));

  } catch(e) { console.error(e); }
})();
})();
